import { createVNode } from "vue";
import { message } from "ant-design-vue";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons-vue";

const Toast = {
  success: (content) => {
    message.success({
      content,
      class: "toast toast-success",
      icon: createVNode(CheckCircleOutlined),
    });
  },

  warning: (content) => {
    message.warning({
      content,
      class: "toast toast-warning",
      icon: createVNode(ExclamationCircleOutlined),
    });
  },

  error: (content) => {
    message.error({
      content,
      class: "toast toast-error",
      icon: createVNode(CloseCircleOutlined),
    });
  },
};

export default Toast;
